// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { ActivateUserData, ActivateUserErrors, ActivateUserResponses, AddOrganizationMemberData, AddOrganizationMemberErrors, AddOrganizationMemberResponses, AddOrganizationProjectMemberData, AddOrganizationProjectMemberErrors, AddOrganizationProjectMemberResponses, ArchiveOrganizationProjectData, ArchiveOrganizationProjectErrors, ArchiveOrganizationProjectResponses, AuthenticateUserAuthenticatePostData, AuthenticateUserAuthenticatePostErrors, AuthenticateUserAuthenticatePostResponses, AuthorizeInternalAuthorizePostData, AuthorizeInternalAuthorizePostErrors, AuthorizeInternalAuthorizePostResponses, AuthorizeProjectsInternalAuthorizeProjectsPostData, AuthorizeProjectsInternalAuthorizeProjectsPostErrors, AuthorizeProjectsInternalAuthorizeProjectsPostResponses, AuthorizeSuperadminInternalAuthorizeSuperadminPostData, AuthorizeSuperadminInternalAuthorizeSuperadminPostErrors, AuthorizeSuperadminInternalAuthorizeSuperadminPostResponses, AuthorizeWithLanguageInternalAuthorizeLanguagePostData, AuthorizeWithLanguageInternalAuthorizeLanguagePostErrors, AuthorizeWithLanguageInternalAuthorizeLanguagePostResponses, BatchInviteOrganizationMembersData, BatchInviteOrganizationMembersErrors, BatchInviteOrganizationMembersResponses, CleanupE2eOrganizationData, CleanupE2eOrganizationErrors, CleanupE2eOrganizationResponses, CleanupE2eUserData, CleanupE2eUserErrors, CleanupE2eUserResponses, CleanupStaleE2eDataData, CleanupStaleE2eDataErrors, CleanupStaleE2eDataResponses, CleanupStaleE2eProjectsData, CleanupStaleE2eProjectsErrors, CleanupStaleE2eProjectsResponses, ClearE2eTestUserQualitySurveyFlagsData, ClearE2eTestUserQualitySurveyFlagsErrors, ClearE2eTestUserQualitySurveyFlagsResponses, ConfirmUserEmailData, ConfirmUserEmailErrors, ConfirmUserEmailResponses, CreateAppSiteImpersonationTokenData, CreateAppSiteImpersonationTokenErrors, CreateAppSiteImpersonationTokenResponses, CreateOrganizationData, CreateOrganizationErrors, CreateOrganizationProjectData, CreateOrganizationProjectErrors, CreateOrganizationProjectInternalData, CreateOrganizationProjectInternalErrors, CreateOrganizationProjectInternalResponses, CreateOrganizationProjectResponses, CreateOrganizationResponses, CreateProfileOptionData, CreateProfileOptionErrors, CreateProfileOptionResponses, CreateUserByEmailData, CreateUserByEmailErrors, CreateUserByEmailResponses, DeactivateUserData, DeactivateUserErrors, DeactivateUserResponses, DeleteOrganizationData, DeleteOrganizationErrors, DeleteOrganizationProjectData, DeleteOrganizationProjectErrors, DeleteOrganizationProjectResponses, DeleteOrganizationResponses, DeleteRuntimeSettingOverrideData, DeleteRuntimeSettingOverrideErrors, DeleteRuntimeSettingOverrideResponses, GetBrandInfoData, GetBrandInfoErrors, GetBrandInfoResponses, GetColleagueAvatarImageData, GetColleagueAvatarImageErrors, GetColleagueAvatarImageResponses, GetCurrentUserInfoData, GetCurrentUserInfoResponses, GetE2eTestUserByRoleData, GetE2eTestUserByRoleErrors, GetE2eTestUserByRoleResponses, GetE2eTestUsersByOrgData, GetE2eTestUsersByOrgErrors, GetE2eTestUsersByOrgResponses, GetE2eTestUsersData, GetE2eTestUsersResponses, GetMemberProfileData, GetMemberProfileErrors, GetMemberProfileResponses, GetMfaProvisioningCapabilitiesData, GetMfaProvisioningCapabilitiesErrors, GetMfaProvisioningCapabilitiesResponses, GetMyAvatarData, GetMyAvatarImageData, GetMyAvatarImageErrors, GetMyAvatarImageResponses, GetMyAvatarResponses, GetMyConsentPreferencesData, GetMyConsentPreferencesErrors, GetMyConsentPreferencesResponses, GetMyOrganizationLanguageContextData, GetMyOrganizationLanguageContextErrors, GetMyOrganizationLanguageContextResponses, GetMyOrganizationProfileData, GetMyOrganizationProfileErrors, GetMyOrganizationProfileResponses, GetMyProfileData, GetMyProfileResponses, GetMyRuntimeSettingData, GetMyRuntimeSettingErrors, GetMyRuntimeSettingResponses, GetOrganizationBackgroundData, GetOrganizationBackgroundErrors, GetOrganizationBackgroundResponses, GetOrganizationLogoUrlsInternalData, GetOrganizationLogoUrlsInternalErrors, GetOrganizationLogoUrlsInternalResponses, GetOrganizationMembersData, GetOrganizationMembersErrors, GetOrganizationMembersResponses, GetOrganizationMetadataInternalData, GetOrganizationMetadataInternalErrors, GetOrganizationMetadataInternalResponses, GetOrganizationMfaPolicyData, GetOrganizationMfaPolicyErrors, GetOrganizationMfaPolicyResponses, GetOrganizationProductSettingsData, GetOrganizationProductSettingsErrors, GetOrganizationProductSettingsResponses, GetOrganizationProfileSettingsData, GetOrganizationProfileSettingsErrors, GetOrganizationProfileSettingsResponses, GetOrganizationProjectData, GetOrganizationProjectErrors, GetOrganizationProjectInternalData, GetOrganizationProjectInternalErrors, GetOrganizationProjectInternalResponses, GetOrganizationProjectResponses, GetOrganizationRuntimeSettingsInternalData, GetOrganizationRuntimeSettingsInternalErrors, GetOrganizationRuntimeSettingsInternalResponses, GetRuntimeSettingsEffectiveInternalData, GetRuntimeSettingsEffectiveInternalErrors, GetRuntimeSettingsEffectiveInternalResponses, GetUserAvatarData, GetUserAvatarErrors, GetUserAvatarImageData, GetUserAvatarImageErrors, GetUserAvatarImageResponses, GetUserAvatarResponses, GetUserByEmailData, GetUserByEmailErrors, GetUserByEmailResponses, GetUserEmailDeliveryHistoryData, GetUserEmailDeliveryHistoryErrors, GetUserEmailDeliveryHistoryResponses, GetUserEmailVerificationStatusData, GetUserEmailVerificationStatusErrors, GetUserEmailVerificationStatusResponses, GetUserMfaRecoveryStatusData, GetUserMfaRecoveryStatusErrors, GetUserMfaRecoveryStatusResponses, GetUsersByIdsData, GetUsersByIdsErrors, GetUsersByIdsResponses, GlobalSearchData, GlobalSearchErrors, GlobalSearchResponses, HealthCheckHealthGetData, HealthCheckHealthGetResponses, InviteOrganizationFacilitatorsData, InviteOrganizationFacilitatorsErrors, InviteOrganizationFacilitatorsResponses, ListMemberProfilesData, ListMemberProfilesErrors, ListMemberProfilesInternalData, ListMemberProfilesInternalErrors, ListMemberProfilesInternalResponses, ListMemberProfilesResponses, ListMyOrganizationFlagsData, ListMyOrganizationFlagsErrors, ListMyOrganizationFlagsResponses, ListMyOrganizationProjectsData, ListMyOrganizationProjectsErrors, ListMyOrganizationProjectsResponses, ListOrganizationFlagUsersInternalData, ListOrganizationFlagUsersInternalErrors, ListOrganizationFlagUsersInternalResponses, ListOrganizationMemberUsersInternalData, ListOrganizationMemberUsersInternalErrors, ListOrganizationMemberUsersInternalResponses, ListOrganizationPeopleData, ListOrganizationPeopleErrors, ListOrganizationPeopleResponses, ListOrganizationProjectAddMemberCandidatesData, ListOrganizationProjectAddMemberCandidatesErrors, ListOrganizationProjectAddMemberCandidatesResponses, ListOrganizationProjectMembersData, ListOrganizationProjectMembersErrors, ListOrganizationProjectMembersResponses, ListOrganizationProjectsData, ListOrganizationProjectsErrors, ListOrganizationProjectsInternalData, ListOrganizationProjectsInternalErrors, ListOrganizationProjectsInternalResponses, ListOrganizationProjectsResponses, ListOrganizationsData, ListOrganizationsErrors, ListOrganizationsResponses, ListProfileOptionsData, ListProfileOptionsErrors, ListProfileOptionsResponses, ListRuntimeSettingDefinitionsData, ListRuntimeSettingDefinitionsErrors, ListRuntimeSettingDefinitionsResponses, ListRuntimeSettingOverridesData, ListRuntimeSettingOverridesErrors, ListRuntimeSettingOverridesResponses, ListUsersData, ListUsersResponses, PatchMyConsentPreferencesData, PatchMyConsentPreferencesErrors, PatchMyConsentPreferencesResponses, PatchMyPreferredLanguageData, PatchMyPreferredLanguageErrors, PatchMyPreferredLanguageResponses, ReassignOrganizationProjectData, ReassignOrganizationProjectErrors, ReassignOrganizationProjectResponses, RemoveMyAvatarData, RemoveMyAvatarResponses, RemoveOrganizationMemberData, RemoveOrganizationMemberErrors, RemoveOrganizationMemberResponses, RemoveOrganizationProjectMemberData, RemoveOrganizationProjectMemberErrors, RemoveOrganizationProjectMemberResponses, RemoveUserAvatarData, RemoveUserAvatarErrors, RemoveUserAvatarResponses, RemoveUserData, RemoveUserErrors, RemoveUserResponses, RequestPasswordResetAuthRequestPasswordResetPostData, RequestPasswordResetAuthRequestPasswordResetPostErrors, RequestPasswordResetAuthRequestPasswordResetPostResponses, RequestVerificationEmailAuthRequestVerificationEmailPostData, RequestVerificationEmailAuthRequestVerificationEmailPostErrors, RequestVerificationEmailAuthRequestVerificationEmailPostResponses, ResetUserMfaData, ResetUserMfaErrors, ResetUserMfaResponses, ResetUserOrganizationFlagData, ResetUserOrganizationFlagErrors, ResetUserOrganizationFlagResponses, RollbackOrganizationMfaData, RollbackOrganizationMfaErrors, RollbackOrganizationMfaResponses, SendMailBatchInternalMailSendBatchPostData, SendMailBatchInternalMailSendBatchPostErrors, SendMailBatchInternalMailSendBatchPostResponses, SendMailInternalMailSendPostData, SendMailInternalMailSendPostErrors, SendMailInternalMailSendPostResponses, SendSensitiveMailBatchInternalMailSensitiveSendBatchPostData, SendSensitiveMailBatchInternalMailSensitiveSendBatchPostErrors, SendSensitiveMailBatchInternalMailSensitiveSendBatchPostResponses, SendUserInvitationData, SendUserInvitationErrors, SendUserInvitationResponses, SetE2eTestUserConsentData, SetE2eTestUserConsentErrors, SetE2eTestUserConsentResponses, SetMyOrganizationFlagData, SetMyOrganizationFlagErrors, SetMyOrganizationFlagResponses, SetupE2eTestProjectData, SetupE2eTestProjectErrors, SetupE2eTestProjectResponses, SyncE2eTestUsersAuthData, SyncE2eTestUsersAuthResponses, UpdateMemberProfileData, UpdateMemberProfileErrors, UpdateMemberProfileResponses, UpdateMyOrganizationProfileData, UpdateMyOrganizationProfileErrors, UpdateMyOrganizationProfileResponses, UpdateMyProfileData, UpdateMyProfileErrors, UpdateMyProfileResponses, UpdateOrganizationBackgroundData, UpdateOrganizationBackgroundErrors, UpdateOrganizationBackgroundResponses, UpdateOrganizationData, UpdateOrganizationDomainsData, UpdateOrganizationDomainsErrors, UpdateOrganizationDomainsResponses, UpdateOrganizationErrors, UpdateOrganizationMemberData, UpdateOrganizationMemberErrors, UpdateOrganizationMemberResponses, UpdateOrganizationNameData, UpdateOrganizationNameErrors, UpdateOrganizationNameResponses, UpdateOrganizationProductSettingsData, UpdateOrganizationProductSettingsErrors, UpdateOrganizationProductSettingsResponses, UpdateOrganizationProfileSettingsData, UpdateOrganizationProfileSettingsErrors, UpdateOrganizationProfileSettingsResponses, UpdateOrganizationProjectData, UpdateOrganizationProjectErrors, UpdateOrganizationProjectMemberData, UpdateOrganizationProjectMemberErrors, UpdateOrganizationProjectMemberResponses, UpdateOrganizationProjectResponses, UpdateOrganizationResponses, UpdateProfileOptionData, UpdateProfileOptionErrors, UpdateProfileOptionResponses, UpdateRecentOrganizationData, UpdateRecentOrganizationErrors, UpdateRecentOrganizationResponses, UploadMyAvatarData, UploadMyAvatarErrors, UploadMyAvatarResponses, UploadOrganizationLogoData, UploadOrganizationLogoErrors, UploadOrganizationLogoResponses, UploadUserAvatarData, UploadUserAvatarErrors, UploadUserAvatarResponses, UpsertE2eRuntimeSettingOverrideData, UpsertE2eRuntimeSettingOverrideErrors, UpsertE2eRuntimeSettingOverrideResponses, UpsertRuntimeSettingOverrideData, UpsertRuntimeSettingOverrideErrors, UpsertRuntimeSettingOverrideResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Get all organizations
 *
 * Retrieves a list of all organizations.
 *
 * - Each organization in the list includes its details and a list of its members.
 *
 * **Permissions:**
 * - Requires superadmin role.
 */
export const listOrganizations = <ThrowOnError extends boolean = false>(options?: Options<ListOrganizationsData, ThrowOnError>): RequestResult<ListOrganizationsResponses, ListOrganizationsErrors, ThrowOnError> => (options?.client ?? client).get<ListOrganizationsResponses, ListOrganizationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/',
    ...options
});

/**
 * Create a new organization
 *
 * Creates a new organization with the specified name.
 * Optionally adds the signed-in user as an organization admin atomically.
 *
 * **Permissions:**
 * - Requires superadmin role.
 */
export const createOrganization = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationData, ThrowOnError>): RequestResult<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError> => (options.client ?? client).post<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/',
    ...options
});

/**
 * Mfa Capabilities
 */
export const getMfaProvisioningCapabilities = <ThrowOnError extends boolean = false>(options?: Options<GetMfaProvisioningCapabilitiesData, ThrowOnError>): RequestResult<GetMfaProvisioningCapabilitiesResponses, GetMfaProvisioningCapabilitiesErrors, ThrowOnError> => (options?.client ?? client).get<GetMfaProvisioningCapabilitiesResponses, GetMfaProvisioningCapabilitiesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/mfa-capabilities/',
    ...options
});

/**
 * Reassign an organization project to a new organization
 *
 * Reassigns an organization project to a new organization.
 *
 * **Permissions:**
 * - Requires superadmin role.
 */
export const reassignOrganizationProject = <ThrowOnError extends boolean = false>(options: Options<ReassignOrganizationProjectData, ThrowOnError>): RequestResult<ReassignOrganizationProjectResponses, ReassignOrganizationProjectErrors, ThrowOnError> => (options.client ?? client).patch<ReassignOrganizationProjectResponses, ReassignOrganizationProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/projects/{org_project_id}/reassign/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an organization
 *
 * Deletes an organization by marking it as deleted. This is a soft delete.
 * **Permissions:**
 * - Requires superadmin role.
 */
export const deleteOrganization = <ThrowOnError extends boolean = false>(options: Options<DeleteOrganizationData, ThrowOnError>): RequestResult<DeleteOrganizationResponses, DeleteOrganizationErrors, ThrowOnError> => (options.client ?? client).delete<DeleteOrganizationResponses, DeleteOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/',
    ...options
});

/**
 * Update organization details
 *
 * Updates organization details such as the display name.
 *
 * **Permissions:**
 * - Requires superadmin (enforced at router level).
 */
export const updateOrganization = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationData, ThrowOnError>): RequestResult<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update organization domains
 *
 * Updates the list of allowed domains for an organization.
 *
 * **Permissions:**
 * - Requires superadmin (enforced at router level).
 */
export const updateOrganizationDomains = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationDomainsData, ThrowOnError>): RequestResult<UpdateOrganizationDomainsResponses, UpdateOrganizationDomainsErrors, ThrowOnError> => (options.client ?? client).put<UpdateOrganizationDomainsResponses, UpdateOrganizationDomainsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/domains/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Profiles
 */
export const listMemberProfiles = <ThrowOnError extends boolean = false>(options: Options<ListMemberProfilesData, ThrowOnError>): RequestResult<ListMemberProfilesResponses, ListMemberProfilesErrors, ThrowOnError> => (options.client ?? client).get<ListMemberProfilesResponses, ListMemberProfilesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/member-profiles/',
    ...options
});

/**
 * Get all members of an organization
 *
 * Retrieves a list of all members for a specific organization.
 *
 * **Permissions:**
 * - Requires superadmin role.
 */
export const getOrganizationMembers = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationMembersData, ThrowOnError>): RequestResult<GetOrganizationMembersResponses, GetOrganizationMembersErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationMembersResponses, GetOrganizationMembersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/members/',
    ...options
});

/**
 * Add a member to an organization
 *
 * Adds a user to an organization with a specific role.
 *
 * - Checks if the user and organization exist.
 * - Creates a new membership record.
 * - Returns the newly created organization membership.
 *
 * **Permissions:**
 * - Requires superadmin role.
 */
export const addOrganizationMember = <ThrowOnError extends boolean = false>(options: Options<AddOrganizationMemberData, ThrowOnError>): RequestResult<AddOrganizationMemberResponses, AddOrganizationMemberErrors, ThrowOnError> => (options.client ?? client).post<AddOrganizationMemberResponses, AddOrganizationMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/members/',
    ...options
});

/**
 * Batch invite organization members
 */
export const batchInviteOrganizationMembers = <ThrowOnError extends boolean = false>(options: Options<BatchInviteOrganizationMembersData, ThrowOnError>): RequestResult<BatchInviteOrganizationMembersResponses, BatchInviteOrganizationMembersErrors, ThrowOnError> => (options.client ?? client).post<BatchInviteOrganizationMembersResponses, BatchInviteOrganizationMembersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/members/batch-invites/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a member from an organization
 *
 * Removes a user's membership from an organization.
 *
 * - Finds and deletes the membership for the given organization and user.
 * - On success, returns `{"ok": True}`.
 * - Raises a `ValueError` if the membership is not found.
 *
 * **Permissions:**
 * - Requires superadmin role.
 */
export const removeOrganizationMember = <ThrowOnError extends boolean = false>(options: Options<RemoveOrganizationMemberData, ThrowOnError>): RequestResult<RemoveOrganizationMemberResponses, RemoveOrganizationMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveOrganizationMemberResponses, RemoveOrganizationMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/members/{user_id}/',
    ...options
});

/**
 * Update a member's role in an organization
 *
 * Updates the role of an existing member within an organization.
 *
 * - Finds the membership for the given organization and user.
 * - Updates the member's role.
 * - Returns the updated organization membership.
 * - Raises a `ValueError` if the membership is not found.
 *
 * **Permissions:**
 * - Requires superadmin role.
 */
export const updateOrganizationMember = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationMemberData, ThrowOnError>): RequestResult<UpdateOrganizationMemberResponses, UpdateOrganizationMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOrganizationMemberResponses, UpdateOrganizationMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/members/{user_id}/',
    ...options
});

/**
 * Get Profile
 */
export const getMemberProfile = <ThrowOnError extends boolean = false>(options: Options<GetMemberProfileData, ThrowOnError>): RequestResult<GetMemberProfileResponses, GetMemberProfileErrors, ThrowOnError> => (options.client ?? client).get<GetMemberProfileResponses, GetMemberProfileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/members/{user_id}/profile/',
    ...options
});

/**
 * Patch Profile
 */
export const updateMemberProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateMemberProfileData, ThrowOnError>): RequestResult<UpdateMemberProfileResponses, UpdateMemberProfileErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMemberProfileResponses, UpdateMemberProfileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/members/{user_id}/profile/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rollback Organization Mfa
 */
export const rollbackOrganizationMfa = <ThrowOnError extends boolean = false>(options: Options<RollbackOrganizationMfaData, ThrowOnError>): RequestResult<RollbackOrganizationMfaResponses, RollbackOrganizationMfaErrors, ThrowOnError> => (options.client ?? client).post<RollbackOrganizationMfaResponses, RollbackOrganizationMfaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/mfa/rollback/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Options
 */
export const listProfileOptions = <ThrowOnError extends boolean = false>(options: Options<ListProfileOptionsData, ThrowOnError>): RequestResult<ListProfileOptionsResponses, ListProfileOptionsErrors, ThrowOnError> => (options.client ?? client).get<ListProfileOptionsResponses, ListProfileOptionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/profile-options/{kind}/',
    ...options
});

/**
 * Create Option
 */
export const createProfileOption = <ThrowOnError extends boolean = false>(options: Options<CreateProfileOptionData, ThrowOnError>): RequestResult<CreateProfileOptionResponses, CreateProfileOptionErrors, ThrowOnError> => (options.client ?? client).post<CreateProfileOptionResponses, CreateProfileOptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/profile-options/{kind}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Patch Option
 */
export const updateProfileOption = <ThrowOnError extends boolean = false>(options: Options<UpdateProfileOptionData, ThrowOnError>): RequestResult<UpdateProfileOptionResponses, UpdateProfileOptionErrors, ThrowOnError> => (options.client ?? client).patch<UpdateProfileOptionResponses, UpdateProfileOptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/profile-options/{kind}/{option_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Settings
 */
export const getOrganizationProfileSettings = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationProfileSettingsData, ThrowOnError>): RequestResult<GetOrganizationProfileSettingsResponses, GetOrganizationProfileSettingsErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationProfileSettingsResponses, GetOrganizationProfileSettingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/profile-settings/',
    ...options
});

/**
 * Patch Settings
 */
export const updateOrganizationProfileSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationProfileSettingsData, ThrowOnError>): RequestResult<UpdateOrganizationProfileSettingsResponses, UpdateOrganizationProfileSettingsErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOrganizationProfileSettingsResponses, UpdateOrganizationProfileSettingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/profile-settings/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all organization projects for an organization
 *
 * Retrieves a list of all organization projects.
 * **Permissions:**
 * - Requires admin role in the organization.
 */
export const listOrganizationProjects = <ThrowOnError extends boolean = false>(options: Options<ListOrganizationProjectsData, ThrowOnError>): RequestResult<ListOrganizationProjectsResponses, ListOrganizationProjectsErrors, ThrowOnError> => (options.client ?? client).get<ListOrganizationProjectsResponses, ListOrganizationProjectsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/projects/',
    ...options
});

/**
 * Create a new organization project
 *
 * Creates a new organization project with the specified name and description.
 * **Permissions:**
 * - Requires admin role in the organization.
 */
export const createOrganizationProject = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationProjectData, ThrowOnError>): RequestResult<CreateOrganizationProjectResponses, CreateOrganizationProjectErrors, ThrowOnError> => (options.client ?? client).post<CreateOrganizationProjectResponses, CreateOrganizationProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/projects/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an organization project
 *
 * Deletes an organization project by marking it as deleted.
 *
 * **Permissions:**
 * - Requires admin role in the organization.
 */
export const deleteOrganizationProject = <ThrowOnError extends boolean = false>(options: Options<DeleteOrganizationProjectData, ThrowOnError>): RequestResult<DeleteOrganizationProjectResponses, DeleteOrganizationProjectErrors, ThrowOnError> => (options.client ?? client).delete<DeleteOrganizationProjectResponses, DeleteOrganizationProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/projects/{org_project_id}/',
    ...options
});

/**
 * Get details of an organization project
 *
 * Retrieves details of a specific organization project.
 * **Permissions:**
 * - Requires admin role in the organization.
 */
export const getOrganizationProject = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationProjectData, ThrowOnError>): RequestResult<GetOrganizationProjectResponses, GetOrganizationProjectErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationProjectResponses, GetOrganizationProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/projects/{org_project_id}/',
    ...options
});

/**
 * Update an organization project
 *
 * Updates an organization project.
 *
 * **Permissions:**
 * - Requires admin role in the organization.
 */
export const updateOrganizationProject = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationProjectData, ThrowOnError>): RequestResult<UpdateOrganizationProjectResponses, UpdateOrganizationProjectErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOrganizationProjectResponses, UpdateOrganizationProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/projects/{org_project_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List organization members who can be added to this project
 *
 * Returns organization members not already on this project, with user display fields
 * for the add-member UI. Org admins can call this; global user list endpoints cannot.
 */
export const listOrganizationProjectAddMemberCandidates = <ThrowOnError extends boolean = false>(options: Options<ListOrganizationProjectAddMemberCandidatesData, ThrowOnError>): RequestResult<ListOrganizationProjectAddMemberCandidatesResponses, ListOrganizationProjectAddMemberCandidatesErrors, ThrowOnError> => (options.client ?? client).get<ListOrganizationProjectAddMemberCandidatesResponses, ListOrganizationProjectAddMemberCandidatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/projects/{org_project_id}/add-member-candidates/',
    ...options
});

/**
 * Archive or unarchive an organization project
 */
export const archiveOrganizationProject = <ThrowOnError extends boolean = false>(options: Options<ArchiveOrganizationProjectData, ThrowOnError>): RequestResult<ArchiveOrganizationProjectResponses, ArchiveOrganizationProjectErrors, ThrowOnError> => (options.client ?? client).post<ArchiveOrganizationProjectResponses, ArchiveOrganizationProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/projects/{org_project_id}/archive/',
    ...options
});

/**
 * List project memberships
 */
export const listOrganizationProjectMembers = <ThrowOnError extends boolean = false>(options: Options<ListOrganizationProjectMembersData, ThrowOnError>): RequestResult<ListOrganizationProjectMembersResponses, ListOrganizationProjectMembersErrors, ThrowOnError> => (options.client ?? client).get<ListOrganizationProjectMembersResponses, ListOrganizationProjectMembersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/projects/{org_project_id}/members/',
    ...options
});

/**
 * Add a project member
 */
export const addOrganizationProjectMember = <ThrowOnError extends boolean = false>(options: Options<AddOrganizationProjectMemberData, ThrowOnError>): RequestResult<AddOrganizationProjectMemberResponses, AddOrganizationProjectMemberErrors, ThrowOnError> => (options.client ?? client).post<AddOrganizationProjectMemberResponses, AddOrganizationProjectMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/projects/{org_project_id}/members/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a project member
 */
export const removeOrganizationProjectMember = <ThrowOnError extends boolean = false>(options: Options<RemoveOrganizationProjectMemberData, ThrowOnError>): RequestResult<RemoveOrganizationProjectMemberResponses, RemoveOrganizationProjectMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveOrganizationProjectMemberResponses, RemoveOrganizationProjectMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/projects/{org_project_id}/members/{membership_user_id}/',
    ...options
});

/**
 * Update a project member role
 */
export const updateOrganizationProjectMember = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationProjectMemberData, ThrowOnError>): RequestResult<UpdateOrganizationProjectMemberResponses, UpdateOrganizationProjectMemberErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOrganizationProjectMemberResponses, UpdateOrganizationProjectMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/organizations/{org_id}/projects/{org_project_id}/members/{membership_user_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List runtime setting definitions
 */
export const listRuntimeSettingDefinitions = <ThrowOnError extends boolean = false>(options?: Options<ListRuntimeSettingDefinitionsData, ThrowOnError>): RequestResult<ListRuntimeSettingDefinitionsResponses, ListRuntimeSettingDefinitionsErrors, ThrowOnError> => (options?.client ?? client).get<ListRuntimeSettingDefinitionsResponses, ListRuntimeSettingDefinitionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/runtime-settings/definitions/',
    ...options
});

/**
 * Delete a runtime setting override
 */
export const deleteRuntimeSettingOverride = <ThrowOnError extends boolean = false>(options: Options<DeleteRuntimeSettingOverrideData, ThrowOnError>): RequestResult<DeleteRuntimeSettingOverrideResponses, DeleteRuntimeSettingOverrideErrors, ThrowOnError> => (options.client ?? client).delete<DeleteRuntimeSettingOverrideResponses, DeleteRuntimeSettingOverrideErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/runtime-settings/overrides/',
    ...options
});

/**
 * List runtime setting overrides
 */
export const listRuntimeSettingOverrides = <ThrowOnError extends boolean = false>(options?: Options<ListRuntimeSettingOverridesData, ThrowOnError>): RequestResult<ListRuntimeSettingOverridesResponses, ListRuntimeSettingOverridesErrors, ThrowOnError> => (options?.client ?? client).get<ListRuntimeSettingOverridesResponses, ListRuntimeSettingOverridesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/runtime-settings/overrides/',
    ...options
});

/**
 * Upsert a runtime setting override
 */
export const upsertRuntimeSettingOverride = <ThrowOnError extends boolean = false>(options: Options<UpsertRuntimeSettingOverrideData, ThrowOnError>): RequestResult<UpsertRuntimeSettingOverrideResponses, UpsertRuntimeSettingOverrideErrors, ThrowOnError> => (options.client ?? client).put<UpsertRuntimeSettingOverrideResponses, UpsertRuntimeSettingOverrideErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/runtime-settings/overrides/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all users
 *
 * Retrieves a list of all users, sorted by email.
 *
 * **Permissions:**
 * - Requires a valid internal service token or superadmin role.
 */
export const listUsers = <ThrowOnError extends boolean = false>(options?: Options<ListUsersData, ThrowOnError>): RequestResult<ListUsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListUsersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/',
    ...options
});

/**
 * Create or get user by email (pre-provision)
 *
 * Idempotent create-by-email for staff provisioning. Creates a PENDING user with
 * no firebase_id so they can be added to an org before first login; on first
 * login the user is linked by email and receives access. If a user with that
 * email already exists, returns them (get-or-create).
 */
export const createUserByEmail = <ThrowOnError extends boolean = false>(options: Options<CreateUserByEmailData, ThrowOnError>): RequestResult<CreateUserByEmailResponses, CreateUserByEmailErrors, ThrowOnError> => (options.client ?? client).post<CreateUserByEmailResponses, CreateUserByEmailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a user by email
 *
 * Retrieves user information by their email address.
 *
 * - This endpoint is intended for internal service-to-service communication.
 *
 * **Permissions:**
 * - Requires a valid internal service token or superadmin role.
 */
export const getUserByEmail = <ThrowOnError extends boolean = false>(options: Options<GetUserByEmailData, ThrowOnError>): RequestResult<GetUserByEmailResponses, GetUserByEmailErrors, ThrowOnError> => (options.client ?? client).post<GetUserByEmailResponses, GetUserByEmailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/by-email/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get users by a list of IDs
 *
 * Retrieves a list of users based on their user IDs.
 *
 * - This endpoint is intended for internal service-to-service communication.
 * - The order of the returned users matches the order of the input IDs.
 *
 * **Permissions:**
 * - Requires a valid internal service token or superadmin role.
 */
export const getUsersByIds = <ThrowOnError extends boolean = false>(options: Options<GetUsersByIdsData, ThrowOnError>): RequestResult<GetUsersByIdsResponses, GetUsersByIdsErrors, ThrowOnError> => (options.client ?? client).post<GetUsersByIdsResponses, GetUsersByIdsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/by-ids/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a user
 *
 * Removes a user from the system entirely.
 *
 * - This endpoint is intended for internal service-to-service communication.
 *
 * **Permissions:**
 * - Requires a valid internal service token or superadmin role.
 */
export const removeUser = <ThrowOnError extends boolean = false>(options: Options<RemoveUserData, ThrowOnError>): RequestResult<RemoveUserResponses, RemoveUserErrors, ThrowOnError> => (options.client ?? client).delete<RemoveUserResponses, RemoveUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/{user_id}/',
    ...options
});

/**
 * Activate a user
 *
 * Activates a user, allowing them to log in and access the system.
 *
 * - This endpoint is intended for internal service-to-service communication.
 *
 * **Permissions:**
 * - Requires a valid internal service token or superadmin role.
 */
export const activateUser = <ThrowOnError extends boolean = false>(options: Options<ActivateUserData, ThrowOnError>): RequestResult<ActivateUserResponses, ActivateUserErrors, ThrowOnError> => (options.client ?? client).post<ActivateUserResponses, ActivateUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/{user_id}/activate/',
    ...options
});

/**
 * Create a Firebase custom token for app-site support impersonation
 *
 * Mint a Firebase custom token for the target user so a superadmin can open
 * app-site as that user. The token is returned to Compose UI and must be
 * delivered to app-site over a browser postMessage channel, not in a URL.
 */
export const createAppSiteImpersonationToken = <ThrowOnError extends boolean = false>(options: Options<CreateAppSiteImpersonationTokenData, ThrowOnError>): RequestResult<CreateAppSiteImpersonationTokenResponses, CreateAppSiteImpersonationTokenErrors, ThrowOnError> => (options.client ?? client).post<CreateAppSiteImpersonationTokenResponses, CreateAppSiteImpersonationTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/{user_id}/app-site-impersonation-token/',
    ...options
});

/**
 * Remove
 */
export const removeUserAvatar = <ThrowOnError extends boolean = false>(options: Options<RemoveUserAvatarData, ThrowOnError>): RequestResult<RemoveUserAvatarResponses, RemoveUserAvatarErrors, ThrowOnError> => (options.client ?? client).delete<RemoveUserAvatarResponses, RemoveUserAvatarErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/{user_id}/avatar/',
    ...options
});

/**
 * Get Avatar
 */
export const getUserAvatar = <ThrowOnError extends boolean = false>(options: Options<GetUserAvatarData, ThrowOnError>): RequestResult<GetUserAvatarResponses, GetUserAvatarErrors, ThrowOnError> => (options.client ?? client).get<GetUserAvatarResponses, GetUserAvatarErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/{user_id}/avatar/',
    ...options
});

/**
 * Upload
 */
export const uploadUserAvatar = <ThrowOnError extends boolean = false>(options: Options<UploadUserAvatarData, ThrowOnError>): RequestResult<UploadUserAvatarResponses, UploadUserAvatarErrors, ThrowOnError> => (options.client ?? client).post<UploadUserAvatarResponses, UploadUserAvatarErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/{user_id}/avatar/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Image
 */
export const getUserAvatarImage = <ThrowOnError extends boolean = false>(options: Options<GetUserAvatarImageData, ThrowOnError>): RequestResult<GetUserAvatarImageResponses, GetUserAvatarImageErrors, ThrowOnError> => (options.client ?? client).get<GetUserAvatarImageResponses, GetUserAvatarImageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/{user_id}/avatar/{size}',
    ...options
});

/**
 * Mark user email as verified (support)
 *
 * Mark the user's Firebase Auth email as verified. Use when the user's
 * signup confirmation email was lost or flagged as spam.
 *
 * **Permissions:**
 * - Requires superadmin role.
 */
export const confirmUserEmail = <ThrowOnError extends boolean = false>(options: Options<ConfirmUserEmailData, ThrowOnError>): RequestResult<ConfirmUserEmailResponses, ConfirmUserEmailErrors, ThrowOnError> => (options.client ?? client).post<ConfirmUserEmailResponses, ConfirmUserEmailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/{user_id}/confirm-email/',
    ...options
});

/**
 * Deactivate a user
 *
 * Deactivates a user, preventing them from logging in.
 *
 * - This endpoint is intended for internal service-to-service communication.
 *
 * **Permissions:**
 * - Requires a valid internal service token or superadmin role.
 */
export const deactivateUser = <ThrowOnError extends boolean = false>(options: Options<DeactivateUserData, ThrowOnError>): RequestResult<DeactivateUserResponses, DeactivateUserErrors, ThrowOnError> => (options.client ?? client).post<DeactivateUserResponses, DeactivateUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/{user_id}/deactivate/',
    ...options
});

/**
 * Mailjet delivery history for a user (support)
 *
 * Fetch recent transactional email events from Mailjet for the user's address.
 * Superadmin support tool; requires Mailjet API credentials on the server.
 */
export const getUserEmailDeliveryHistory = <ThrowOnError extends boolean = false>(options: Options<GetUserEmailDeliveryHistoryData, ThrowOnError>): RequestResult<GetUserEmailDeliveryHistoryResponses, GetUserEmailDeliveryHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetUserEmailDeliveryHistoryResponses, GetUserEmailDeliveryHistoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/{user_id}/email-delivery-history/',
    ...options
});

/**
 * Get user email verification status
 *
 * Get the user's email_verified state from Firebase Auth.
 * Returns 404 only if the user does not exist in this system.
 */
export const getUserEmailVerificationStatus = <ThrowOnError extends boolean = false>(options: Options<GetUserEmailVerificationStatusData, ThrowOnError>): RequestResult<GetUserEmailVerificationStatusResponses, GetUserEmailVerificationStatusErrors, ThrowOnError> => (options.client ?? client).get<GetUserEmailVerificationStatusResponses, GetUserEmailVerificationStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/{user_id}/email-verification-status/',
    ...options
});

/**
 * Get authoritative MFA recovery status (support)
 */
export const getUserMfaRecoveryStatus = <ThrowOnError extends boolean = false>(options: Options<GetUserMfaRecoveryStatusData, ThrowOnError>): RequestResult<GetUserMfaRecoveryStatusResponses, GetUserMfaRecoveryStatusErrors, ThrowOnError> => (options.client ?? client).get<GetUserMfaRecoveryStatusResponses, GetUserMfaRecoveryStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/{user_id}/mfa-recovery-status/',
    ...options
});

/**
 * Reset a user organization flag
 *
 * Deletes a per-user organization flag. Used by superadmins to reset
 * onboarding completion and force the user through onboarding again.
 */
export const resetUserOrganizationFlag = <ThrowOnError extends boolean = false>(options: Options<ResetUserOrganizationFlagData, ThrowOnError>): RequestResult<ResetUserOrganizationFlagResponses, ResetUserOrganizationFlagErrors, ThrowOnError> => (options.client ?? client).delete<ResetUserOrganizationFlagResponses, ResetUserOrganizationFlagErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/{user_id}/organizations/{org_id}/flags/{flag_key}/',
    ...options
});

/**
 * Reset MFA factors for a user (support)
 */
export const resetUserMfa = <ThrowOnError extends boolean = false>(options: Options<ResetUserMfaData, ThrowOnError>): RequestResult<ResetUserMfaResponses, ResetUserMfaErrors, ThrowOnError> => (options.client ?? client).post<ResetUserMfaResponses, ResetUserMfaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/{user_id}/reset-mfa/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send invitation email to a PENDING or ACTIVE user
 */
export const sendUserInvitation = <ThrowOnError extends boolean = false>(options: Options<SendUserInvitationData, ThrowOnError>): RequestResult<SendUserInvitationResponses, SendUserInvitationErrors, ThrowOnError> => (options.client ?? client).post<SendUserInvitationResponses, SendUserInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/admin/users/{user_id}/send-invitation/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request Password Reset
 */
export const requestPasswordResetAuthRequestPasswordResetPost = <ThrowOnError extends boolean = false>(options: Options<RequestPasswordResetAuthRequestPasswordResetPostData, ThrowOnError>): RequestResult<RequestPasswordResetAuthRequestPasswordResetPostResponses, RequestPasswordResetAuthRequestPasswordResetPostErrors, ThrowOnError> => (options.client ?? client).post<RequestPasswordResetAuthRequestPasswordResetPostResponses, RequestPasswordResetAuthRequestPasswordResetPostErrors, ThrowOnError>({
    url: '/auth/request-password-reset/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request Verification Email
 */
export const requestVerificationEmailAuthRequestVerificationEmailPost = <ThrowOnError extends boolean = false>(options?: Options<RequestVerificationEmailAuthRequestVerificationEmailPostData, ThrowOnError>): RequestResult<RequestVerificationEmailAuthRequestVerificationEmailPostResponses, RequestVerificationEmailAuthRequestVerificationEmailPostErrors, ThrowOnError> => (options?.client ?? client).post<RequestVerificationEmailAuthRequestVerificationEmailPostResponses, RequestVerificationEmailAuthRequestVerificationEmailPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/request-verification-email/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get organization logo URLs (internal)
 *
 * Returns organization-level logo URLs for service-to-service display inheritance.
 *
 * **Permissions:**
 * - Requires a valid internal service token.
 */
export const getOrganizationLogoUrlsInternal = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationLogoUrlsInternalData, ThrowOnError>): RequestResult<GetOrganizationLogoUrlsInternalResponses, GetOrganizationLogoUrlsInternalErrors, ThrowOnError> => (options.client ?? client).post<GetOrganizationLogoUrlsInternalResponses, GetOrganizationLogoUrlsInternalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/backchannel/organizations/logo-urls/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Organization Flag Users Internal
 */
export const listOrganizationFlagUsersInternal = <ThrowOnError extends boolean = false>(options: Options<ListOrganizationFlagUsersInternalData, ThrowOnError>): RequestResult<ListOrganizationFlagUsersInternalResponses, ListOrganizationFlagUsersInternalErrors, ThrowOnError> => (options.client ?? client).post<ListOrganizationFlagUsersInternalResponses, ListOrganizationFlagUsersInternalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/backchannel/organizations/{org_id}/flags/{flag_key}/users/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Member Profiles Internal
 */
export const listMemberProfilesInternal = <ThrowOnError extends boolean = false>(options: Options<ListMemberProfilesInternalData, ThrowOnError>): RequestResult<ListMemberProfilesInternalResponses, ListMemberProfilesInternalErrors, ThrowOnError> => (options.client ?? client).get<ListMemberProfilesInternalResponses, ListMemberProfilesInternalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/backchannel/organizations/{org_id}/members/profiles/',
    ...options
});

/**
 * List Organization Member Users Internal
 */
export const listOrganizationMemberUsersInternal = <ThrowOnError extends boolean = false>(options: Options<ListOrganizationMemberUsersInternalData, ThrowOnError>): RequestResult<ListOrganizationMemberUsersInternalResponses, ListOrganizationMemberUsersInternalErrors, ThrowOnError> => (options.client ?? client).get<ListOrganizationMemberUsersInternalResponses, ListOrganizationMemberUsersInternalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/backchannel/organizations/{org_id}/members/users/',
    ...options
});

/**
 * Get organization metadata (internal)
 */
export const getOrganizationMetadataInternal = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationMetadataInternalData, ThrowOnError>): RequestResult<GetOrganizationMetadataInternalResponses, GetOrganizationMetadataInternalErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationMetadataInternalResponses, GetOrganizationMetadataInternalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/backchannel/organizations/{org_id}/metadata/',
    ...options
});

/**
 * List organization projects (internal)
 *
 * Lists organization projects for service-to-service calls (same filters as admin list).
 *
 * **Permissions:**
 * - Requires a valid internal service token.
 * - When ``user_id`` is provided, project visibility is scoped to that user.
 * - When ``user_id`` is omitted, all matching organization projects are returned.
 */
export const listOrganizationProjectsInternal = <ThrowOnError extends boolean = false>(options: Options<ListOrganizationProjectsInternalData, ThrowOnError>): RequestResult<ListOrganizationProjectsInternalResponses, ListOrganizationProjectsInternalErrors, ThrowOnError> => (options.client ?? client).get<ListOrganizationProjectsInternalResponses, ListOrganizationProjectsInternalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/backchannel/organizations/{org_id}/projects/',
    ...options
});

/**
 * Create organization project (internal)
 */
export const createOrganizationProjectInternal = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationProjectInternalData, ThrowOnError>): RequestResult<CreateOrganizationProjectInternalResponses, CreateOrganizationProjectInternalErrors, ThrowOnError> => (options.client ?? client).post<CreateOrganizationProjectInternalResponses, CreateOrganizationProjectInternalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/backchannel/organizations/{org_id}/projects/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get organization project by ID (internal)
 */
export const getOrganizationProjectInternal = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationProjectInternalData, ThrowOnError>): RequestResult<GetOrganizationProjectInternalResponses, GetOrganizationProjectInternalErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationProjectInternalResponses, GetOrganizationProjectInternalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/backchannel/organizations/{org_id}/projects/{org_project_id}/',
    ...options
});

/**
 * Resolve organization runtime settings (internal)
 */
export const getOrganizationRuntimeSettingsInternal = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationRuntimeSettingsInternalData, ThrowOnError>): RequestResult<GetOrganizationRuntimeSettingsInternalResponses, GetOrganizationRuntimeSettingsInternalErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationRuntimeSettingsInternalResponses, GetOrganizationRuntimeSettingsInternalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/backchannel/organizations/{organization_id}/runtime-settings/',
    ...options
});

/**
 * Resolve effective runtime settings (internal)
 */
export const getRuntimeSettingsEffectiveInternal = <ThrowOnError extends boolean = false>(options: Options<GetRuntimeSettingsEffectiveInternalData, ThrowOnError>): RequestResult<GetRuntimeSettingsEffectiveInternalResponses, GetRuntimeSettingsEffectiveInternalErrors, ThrowOnError> => (options.client ?? client).get<GetRuntimeSettingsEffectiveInternalResponses, GetRuntimeSettingsEffectiveInternalErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/backchannel/runtime-settings/effective/',
    ...options
});

/**
 * Health Check
 */
export const healthCheckHealthGet = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckHealthGetData, ThrowOnError>): RequestResult<HealthCheckHealthGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthCheckHealthGetResponses, unknown, ThrowOnError>({ url: '/health/', ...options });

/**
 * Authorize With Language
 *
 * @deprecated
 */
export const authorizeWithLanguageInternalAuthorizeLanguagePost = <ThrowOnError extends boolean = false>(options: Options<AuthorizeWithLanguageInternalAuthorizeLanguagePostData, ThrowOnError>): RequestResult<AuthorizeWithLanguageInternalAuthorizeLanguagePostResponses, AuthorizeWithLanguageInternalAuthorizeLanguagePostErrors, ThrowOnError> => (options.client ?? client).post<AuthorizeWithLanguageInternalAuthorizeLanguagePostResponses, AuthorizeWithLanguageInternalAuthorizeLanguagePostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/authorize-language/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Authorize Projects
 *
 * Authorizes a user against several organization projects in one call.
 *
 * - This endpoint is intended for internal service-to-service communication and is protected by an internal service token.
 * - It applies the same decision as `/authorize/`, once per requested project, and returns the authorized projects in full plus the ids the user may not act on.
 * - Ids that do not belong to the organization are reported as denied rather than as an error.
 *
 * **Permissions:**
 * - Requires a valid internal service token.
 */
export const authorizeProjectsInternalAuthorizeProjectsPost = <ThrowOnError extends boolean = false>(options: Options<AuthorizeProjectsInternalAuthorizeProjectsPostData, ThrowOnError>): RequestResult<AuthorizeProjectsInternalAuthorizeProjectsPostResponses, AuthorizeProjectsInternalAuthorizeProjectsPostErrors, ThrowOnError> => (options.client ?? client).post<AuthorizeProjectsInternalAuthorizeProjectsPostResponses, AuthorizeProjectsInternalAuthorizeProjectsPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/authorize-projects/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Authorize Superadmin
 *
 * Authorizes a user's superadmin access.
 *
 * - This endpoint is intended for internal service-to-service communication and is protected by an internal service token.
 * - It takes a user's token and returns the user's permissions if they are authorized.
 *
 * **Permissions:**
 * - Requires a valid internal service token.
 */
export const authorizeSuperadminInternalAuthorizeSuperadminPost = <ThrowOnError extends boolean = false>(options: Options<AuthorizeSuperadminInternalAuthorizeSuperadminPostData, ThrowOnError>): RequestResult<AuthorizeSuperadminInternalAuthorizeSuperadminPostResponses, AuthorizeSuperadminInternalAuthorizeSuperadminPostErrors, ThrowOnError> => (options.client ?? client).post<AuthorizeSuperadminInternalAuthorizeSuperadminPostResponses, AuthorizeSuperadminInternalAuthorizeSuperadminPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/authorize-superadmin/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Authorize
 *
 * Authorizes a user's access to a specific organization and project based on their role.
 *
 * - This endpoint is intended for internal service-to-service communication and is protected by an internal service token.
 * - It takes a user's token, organization ID, and the required role, and returns the user's permissions if they are authorized.
 *
 * **Permissions:**
 * - Requires a valid internal service token.
 */
export const authorizeInternalAuthorizePost = <ThrowOnError extends boolean = false>(options: Options<AuthorizeInternalAuthorizePostData, ThrowOnError>): RequestResult<AuthorizeInternalAuthorizePostResponses, AuthorizeInternalAuthorizePostErrors, ThrowOnError> => (options.client ?? client).post<AuthorizeInternalAuthorizePostResponses, AuthorizeInternalAuthorizePostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/authorize/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cleanup E2E test organization and all related data
 *
 * Deletes a test organization and all its projects, memberships, and related data in other services.
 *
 * **Safety Checks:**
 * - Organization name must start with 'e2e-test-'.
 * - Organization name must match 'confirm_org_name' exactly.
 */
export const cleanupE2eOrganization = <ThrowOnError extends boolean = false>(options: Options<CleanupE2eOrganizationData, ThrowOnError>): RequestResult<CleanupE2eOrganizationResponses, CleanupE2eOrganizationErrors, ThrowOnError> => (options.client ?? client).delete<CleanupE2eOrganizationResponses, CleanupE2eOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/e2e/cleanup/organization/{org_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Hard cleanup stale E2E projects only
 *
 * Hard deletes stale organization projects in E2E organizations (e2e-alpha, e2e-slides) and
 * cascades project-level cleanup in discovery and metadata. Project names are not filtered;
 * any org project under those organizations may be removed when stale.
 * Organizations and users are never deleted by this endpoint.
 */
export const cleanupStaleE2eProjects = <ThrowOnError extends boolean = false>(options?: Options<CleanupStaleE2eProjectsData, ThrowOnError>): RequestResult<CleanupStaleE2eProjectsResponses, CleanupStaleE2eProjectsErrors, ThrowOnError> => (options?.client ?? client).delete<CleanupStaleE2eProjectsResponses, CleanupStaleE2eProjectsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/e2e/cleanup/stale-projects/',
    ...options
});

/**
 * Cleanup stale E2E test data
 *
 * Finds and deletes all E2E organizations and users created more than max_age_hours ago.
 */
export const cleanupStaleE2eData = <ThrowOnError extends boolean = false>(options?: Options<CleanupStaleE2eDataData, ThrowOnError>): RequestResult<CleanupStaleE2eDataResponses, CleanupStaleE2eDataErrors, ThrowOnError> => (options?.client ?? client).delete<CleanupStaleE2eDataResponses, CleanupStaleE2eDataErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/e2e/cleanup/stale/',
    ...options
});

/**
 * Cleanup E2E test user
 *
 * Deletes a test user from DB and Firebase.
 *
 * **Safety Checks:**
 * - User email must start with 'e2e-test-' OR end with '@e2e-test.canucci.com'.
 * - User email must match 'confirm_email' exactly.
 */
export const cleanupE2eUser = <ThrowOnError extends boolean = false>(options: Options<CleanupE2eUserData, ThrowOnError>): RequestResult<CleanupE2eUserResponses, CleanupE2eUserErrors, ThrowOnError> => (options.client ?? client).delete<CleanupE2eUserResponses, CleanupE2eUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/e2e/cleanup/user/{user_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upsert an E2E organization runtime setting override
 *
 * Sets organization-scoped runtime settings for seeded E2E organizations only.
 *
 * **Permissions:**
 * - Requires a valid internal service token.
 * - Only e2e-alpha and e2e-slides organizations are allowed.
 */
export const upsertE2eRuntimeSettingOverride = <ThrowOnError extends boolean = false>(options: Options<UpsertE2eRuntimeSettingOverrideData, ThrowOnError>): RequestResult<UpsertE2eRuntimeSettingOverrideResponses, UpsertE2eRuntimeSettingOverrideErrors, ThrowOnError> => (options.client ?? client).put<UpsertE2eRuntimeSettingOverrideResponses, UpsertE2eRuntimeSettingOverrideErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/e2e/organizations/{organization_id}/runtime-settings/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Setup E2E test project
 *
 * Creates a test organization project for E2E testing.
 *
 * **Permissions:**
 * - Requires a valid internal service token.
 */
export const setupE2eTestProject = <ThrowOnError extends boolean = false>(options: Options<SetupE2eTestProjectData, ThrowOnError>): RequestResult<SetupE2eTestProjectResponses, SetupE2eTestProjectErrors, ThrowOnError> => (options.client ?? client).post<SetupE2eTestProjectResponses, SetupE2eTestProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/e2e/setup-project/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all E2E test users
 *
 * Retrieves all fixed E2E test users with their credentials.
 *
 * **Permissions:**
 * - Requires a valid internal service token.
 */
export const getE2eTestUsers = <ThrowOnError extends boolean = false>(options?: Options<GetE2eTestUsersData, ThrowOnError>): RequestResult<GetE2eTestUsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetE2eTestUsersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/e2e/test-users/',
    ...options
});

/**
 * Get E2E test users by organization
 *
 * Retrieves all E2E test users for a specific organization.
 *
 * **Parameters:**
 * - org_name: Organization name (e2e-alpha or e2e-slides)
 *
 * **Permissions:**
 * - Requires a valid internal service token.
 */
export const getE2eTestUsersByOrg = <ThrowOnError extends boolean = false>(options: Options<GetE2eTestUsersByOrgData, ThrowOnError>): RequestResult<GetE2eTestUsersByOrgResponses, GetE2eTestUsersByOrgErrors, ThrowOnError> => (options.client ?? client).get<GetE2eTestUsersByOrgResponses, GetE2eTestUsersByOrgErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/e2e/test-users/by-org/{org_name}/',
    ...options
});

/**
 * Get E2E test user by role
 *
 * Retrieves an E2E test user by role with optional index (e.g., 2nd admin).
 *
 * **Parameters:**
 * - role: Role name (ORG_ADMIN, ORG_EDITOR, ORG_VIEWER, RESPONDENT, FACILITATOR; legacy names also accepted)
 * - index: Index of user with this role (default: 0 for first user)
 * - org_name: Optional organization filter (e2e-alpha or e2e-slides)
 *
 * **Permissions:**
 * - Requires a valid internal service token.
 */
export const getE2eTestUserByRole = <ThrowOnError extends boolean = false>(options: Options<GetE2eTestUserByRoleData, ThrowOnError>): RequestResult<GetE2eTestUserByRoleResponses, GetE2eTestUserByRoleErrors, ThrowOnError> => (options.client ?? client).get<GetE2eTestUserByRoleResponses, GetE2eTestUserByRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/e2e/test-users/by-role/{role}/',
    ...options
});

/**
 * Sync fixed E2E test users to DB and Firebase Auth
 *
 * Ensures the fixed E2E test users exist in both the organization DB and
 * Firebase Auth, with active DB status, verified Firebase email, and the
 * current E2E password.
 *
 * **Permissions:**
 * - Requires a valid internal service token.
 */
export const syncE2eTestUsersAuth = <ThrowOnError extends boolean = false>(options?: Options<SyncE2eTestUsersAuthData, ThrowOnError>): RequestResult<SyncE2eTestUsersAuthResponses, unknown, ThrowOnError> => (options?.client ?? client).post<SyncE2eTestUsersAuthResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/e2e/test-users/sync-auth/',
    ...options
});

/**
 * Set E2E test user consent state
 *
 * Sets app-site analytics consent for a seeded E2E test user.
 *
 * **Permissions:**
 * - Requires a valid internal service token.
 */
export const setE2eTestUserConsent = <ThrowOnError extends boolean = false>(options: Options<SetE2eTestUserConsentData, ThrowOnError>): RequestResult<SetE2eTestUserConsentResponses, SetE2eTestUserConsentErrors, ThrowOnError> => (options.client ?? client).put<SetE2eTestUserConsentResponses, SetE2eTestUserConsentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/e2e/test-users/{user_id}/consent/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clear E2E test user facilitator quality survey flags
 *
 * Forgets that a seeded E2E user was asked for facilitator feedback in this organization,
 * so the survey can be triggered again on the next run.
 *
 * **Permissions:**
 * - Requires a valid internal service token.
 */
export const clearE2eTestUserQualitySurveyFlags = <ThrowOnError extends boolean = false>(options: Options<ClearE2eTestUserQualitySurveyFlagsData, ThrowOnError>): RequestResult<ClearE2eTestUserQualitySurveyFlagsResponses, ClearE2eTestUserQualitySurveyFlagsErrors, ThrowOnError> => (options.client ?? client).delete<ClearE2eTestUserQualitySurveyFlagsResponses, ClearE2eTestUserQualitySurveyFlagsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/e2e/test-users/{user_id}/organizations/{org_id}/quality-survey-flags/',
    ...options
});

/**
 * Send Mail Batch
 */
export const sendMailBatchInternalMailSendBatchPost = <ThrowOnError extends boolean = false>(options: Options<SendMailBatchInternalMailSendBatchPostData, ThrowOnError>): RequestResult<SendMailBatchInternalMailSendBatchPostResponses, SendMailBatchInternalMailSendBatchPostErrors, ThrowOnError> => (options.client ?? client).post<SendMailBatchInternalMailSendBatchPostResponses, SendMailBatchInternalMailSendBatchPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/mail/send-batch/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Mail
 */
export const sendMailInternalMailSendPost = <ThrowOnError extends boolean = false>(options: Options<SendMailInternalMailSendPostData, ThrowOnError>): RequestResult<SendMailInternalMailSendPostResponses, SendMailInternalMailSendPostErrors, ThrowOnError> => (options.client ?? client).post<SendMailInternalMailSendPostResponses, SendMailInternalMailSendPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/mail/send/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Sensitive Mail Batch
 */
export const sendSensitiveMailBatchInternalMailSensitiveSendBatchPost = <ThrowOnError extends boolean = false>(options: Options<SendSensitiveMailBatchInternalMailSensitiveSendBatchPostData, ThrowOnError>): RequestResult<SendSensitiveMailBatchInternalMailSensitiveSendBatchPostResponses, SendSensitiveMailBatchInternalMailSensitiveSendBatchPostErrors, ThrowOnError> => (options.client ?? client).post<SendSensitiveMailBatchInternalMailSensitiveSendBatchPostResponses, SendSensitiveMailBatchInternalMailSensitiveSendBatchPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/internal/mail/sensitive/send-batch/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Invite facilitators to the organization
 */
export const inviteOrganizationFacilitators = <ThrowOnError extends boolean = false>(options: Options<InviteOrganizationFacilitatorsData, ThrowOnError>): RequestResult<InviteOrganizationFacilitatorsResponses, InviteOrganizationFacilitatorsErrors, ThrowOnError> => (options.client ?? client).post<InviteOrganizationFacilitatorsResponses, InviteOrganizationFacilitatorsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organizations/{org_id}/facilitator-invitations/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Organization Mfa Policy
 */
export const getOrganizationMfaPolicy = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationMfaPolicyData, ThrowOnError>): RequestResult<GetOrganizationMfaPolicyResponses, GetOrganizationMfaPolicyErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationMfaPolicyResponses, GetOrganizationMfaPolicyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organizations/{org_id}/mfa-policy/',
    ...options
});

/**
 * List People
 */
export const listOrganizationPeople = <ThrowOnError extends boolean = false>(options: Options<ListOrganizationPeopleData, ThrowOnError>): RequestResult<ListOrganizationPeopleResponses, ListOrganizationPeopleErrors, ThrowOnError> => (options.client ?? client).get<ListOrganizationPeopleResponses, ListOrganizationPeopleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organizations/{org_id}/people/',
    ...options
});

/**
 * Own Profile
 */
export const getMyOrganizationProfile = <ThrowOnError extends boolean = false>(options: Options<GetMyOrganizationProfileData, ThrowOnError>): RequestResult<GetMyOrganizationProfileResponses, GetMyOrganizationProfileErrors, ThrowOnError> => (options.client ?? client).get<GetMyOrganizationProfileResponses, GetMyOrganizationProfileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organizations/{org_id}/people/me/',
    ...options
});

/**
 * Patch Own Profile
 */
export const updateMyOrganizationProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateMyOrganizationProfileData, ThrowOnError>): RequestResult<UpdateMyOrganizationProfileResponses, UpdateMyOrganizationProfileErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMyOrganizationProfileResponses, UpdateMyOrganizationProfileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organizations/{org_id}/people/me/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Image
 */
export const getColleagueAvatarImage = <ThrowOnError extends boolean = false>(options: Options<GetColleagueAvatarImageData, ThrowOnError>): RequestResult<GetColleagueAvatarImageResponses, GetColleagueAvatarImageErrors, ThrowOnError> => (options.client ?? client).get<GetColleagueAvatarImageResponses, GetColleagueAvatarImageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organizations/{org_id}/people/{user_id}/avatar/{size}',
    ...options
});

/**
 * Get the organization's product settings
 */
export const getOrganizationProductSettings = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationProductSettingsData, ThrowOnError>): RequestResult<GetOrganizationProductSettingsResponses, GetOrganizationProductSettingsErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationProductSettingsResponses, GetOrganizationProductSettingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organizations/{org_id}/product-settings/',
    ...options
});

/**
 * Update the organization's product settings
 *
 * Save the setup groups in one transaction; rules live in the service.
 */
export const updateOrganizationProductSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationProductSettingsData, ThrowOnError>): RequestResult<UpdateOrganizationProductSettingsResponses, UpdateOrganizationProductSettingsErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOrganizationProductSettingsResponses, UpdateOrganizationProductSettingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organizations/{org_id}/product-settings/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get organization background
 */
export const getOrganizationBackground = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationBackgroundData, ThrowOnError>): RequestResult<GetOrganizationBackgroundResponses, GetOrganizationBackgroundErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationBackgroundResponses, GetOrganizationBackgroundErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organizations/{org_id}/settings/background/',
    ...options
});

/**
 * Update organization background
 */
export const updateOrganizationBackground = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationBackgroundData, ThrowOnError>): RequestResult<UpdateOrganizationBackgroundResponses, UpdateOrganizationBackgroundErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOrganizationBackgroundResponses, UpdateOrganizationBackgroundErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organizations/{org_id}/settings/background/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload organization logo
 */
export const uploadOrganizationLogo = <ThrowOnError extends boolean = false>(options: Options<UploadOrganizationLogoData, ThrowOnError>): RequestResult<UploadOrganizationLogoResponses, UploadOrganizationLogoErrors, ThrowOnError> => (options.client ?? client).post<UploadOrganizationLogoResponses, UploadOrganizationLogoErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organizations/{org_id}/settings/logo/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Update organization name
 *
 * Updates the organization display name.
 *
 * **Permissions:**
 * - Superadmin, or organization member with ORG_ADMIN role.
 */
export const updateOrganizationName = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationNameData, ThrowOnError>): RequestResult<UpdateOrganizationNameResponses, UpdateOrganizationNameErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOrganizationNameResponses, UpdateOrganizationNameErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/organizations/{org_id}/settings/name/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Authenticate a user with a Firebase ID token.
 *
 * Authenticates a user based on a Firebase ID token and implements a Just-in-Time (JIT) provisioning flow.
 *
 * - **Validates the Firebase token**: If the token is invalid or expired, a `401 Unauthorized` error is returned.
 * - **Checks for existing user**: Looks up the user by their Firebase ID.
 * - **JIT Provisioning**: If the user does not exist, a new user record is created with a `PENDING` status. The user's email from the Firebase token is used for both the email and username fields.
 * - **Returns user data**:
 * - If the user is `ACTIVE`, the response includes their details and a list of their organization memberships.
 * - If the user is `PENDING`, the response includes their details and an empty list of organizations. The frontend should use this status to inform the user that their account is awaiting administrator approval.
 *
 * **Permissions:**
 * - This endpoint is open to all users with a valid Firebase ID token.
 */
export const authenticateUserAuthenticatePost = <ThrowOnError extends boolean = false>(options: Options<AuthenticateUserAuthenticatePostData, ThrowOnError>): RequestResult<AuthenticateUserAuthenticatePostResponses, AuthenticateUserAuthenticatePostErrors, ThrowOnError> => (options.client ?? client).post<AuthenticateUserAuthenticatePostResponses, AuthenticateUserAuthenticatePostErrors, ThrowOnError>({
    url: '/user/authenticate/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get current user info
 *
 * Retrieves the profile information for the currently authenticated user.
 *
 * - Fetches user details from the database based on the Firebase token.
 * - If the user is `ACTIVE`, it also returns a list of organizations they are a member of, including their role in each.
 *
 * **Permissions:**
 * - Requires a valid Firebase authentication token.
 */
export const getCurrentUserInfo = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentUserInfoData, ThrowOnError>): RequestResult<GetCurrentUserInfoResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetCurrentUserInfoResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/me/',
    ...options
});

/**
 * Remove
 */
export const removeMyAvatar = <ThrowOnError extends boolean = false>(options?: Options<RemoveMyAvatarData, ThrowOnError>): RequestResult<RemoveMyAvatarResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<RemoveMyAvatarResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/me/avatar/',
    ...options
});

/**
 * Metadata
 */
export const getMyAvatar = <ThrowOnError extends boolean = false>(options?: Options<GetMyAvatarData, ThrowOnError>): RequestResult<GetMyAvatarResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMyAvatarResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/me/avatar/',
    ...options
});

/**
 * Upload
 */
export const uploadMyAvatar = <ThrowOnError extends boolean = false>(options: Options<UploadMyAvatarData, ThrowOnError>): RequestResult<UploadMyAvatarResponses, UploadMyAvatarErrors, ThrowOnError> => (options.client ?? client).post<UploadMyAvatarResponses, UploadMyAvatarErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/me/avatar/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Image
 */
export const getMyAvatarImage = <ThrowOnError extends boolean = false>(options: Options<GetMyAvatarImageData, ThrowOnError>): RequestResult<GetMyAvatarImageResponses, GetMyAvatarImageErrors, ThrowOnError> => (options.client ?? client).get<GetMyAvatarImageResponses, GetMyAvatarImageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/me/avatar/{size}',
    ...options
});

/**
 * Get current user consent preferences
 *
 * Returns effective consent for the authenticated user in the given organization.
 *
 * When the organization has contract-level analytics consent, returns a granted
 * organization-contract category. Otherwise returns stored user preferences.
 *
 * **Permissions:**
 * - Requires a valid Firebase authentication token.
 * - The user must be a member of the organization.
 */
export const getMyConsentPreferences = <ThrowOnError extends boolean = false>(options: Options<GetMyConsentPreferencesData, ThrowOnError>): RequestResult<GetMyConsentPreferencesResponses, GetMyConsentPreferencesErrors, ThrowOnError> => (options.client ?? client).get<GetMyConsentPreferencesResponses, GetMyConsentPreferencesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/me/consent/',
    ...options
});

/**
 * Update current user consent preferences
 *
 * Merges the provided consent category into ``User.consent_preferences`` JSON.
 * ``updated_at`` is set server-side; schema version ``v`` is written as needed.
 *
 * Rejected with 409 when analytics consent is managed by the organization contract.
 *
 * **Permissions:**
 * - Requires a valid Firebase authentication token.
 * - The user must be a member of the organization.
 */
export const patchMyConsentPreferences = <ThrowOnError extends boolean = false>(options: Options<PatchMyConsentPreferencesData, ThrowOnError>): RequestResult<PatchMyConsentPreferencesResponses, PatchMyConsentPreferencesErrors, ThrowOnError> => (options.client ?? client).patch<PatchMyConsentPreferencesResponses, PatchMyConsentPreferencesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/me/consent/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List My Organization Flags
 */
export const listMyOrganizationFlags = <ThrowOnError extends boolean = false>(options: Options<ListMyOrganizationFlagsData, ThrowOnError>): RequestResult<ListMyOrganizationFlagsResponses, ListMyOrganizationFlagsErrors, ThrowOnError> => (options.client ?? client).get<ListMyOrganizationFlagsResponses, ListMyOrganizationFlagsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/me/organizations/{org_id}/flags/',
    ...options
});

/**
 * Set My Organization Flag
 */
export const setMyOrganizationFlag = <ThrowOnError extends boolean = false>(options: Options<SetMyOrganizationFlagData, ThrowOnError>): RequestResult<SetMyOrganizationFlagResponses, SetMyOrganizationFlagErrors, ThrowOnError> => (options.client ?? client).post<SetMyOrganizationFlagResponses, SetMyOrganizationFlagErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/me/organizations/{org_id}/flags/{flag_key}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolve language context for the current user and organization
 */
export const getMyOrganizationLanguageContext = <ThrowOnError extends boolean = false>(options: Options<GetMyOrganizationLanguageContextData, ThrowOnError>): RequestResult<GetMyOrganizationLanguageContextResponses, GetMyOrganizationLanguageContextErrors, ThrowOnError> => (options.client ?? client).get<GetMyOrganizationLanguageContextResponses, GetMyOrganizationLanguageContextErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/me/organizations/{org_id}/language-context/',
    ...options
});

/**
 * Get all projects for a specific organization the user is a member of
 *
 * Retrieves all projects for a specific organization, provided the user is a member of it.
 *
 * **Permissions:**
 * - Requires a valid Firebase authentication token.
 * - The user must be a member of the organization.
 */
export const listMyOrganizationProjects = <ThrowOnError extends boolean = false>(options: Options<ListMyOrganizationProjectsData, ThrowOnError>): RequestResult<ListMyOrganizationProjectsResponses, ListMyOrganizationProjectsErrors, ThrowOnError> => (options.client ?? client).get<ListMyOrganizationProjectsResponses, ListMyOrganizationProjectsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/me/organizations/{org_id}/projects/',
    ...options
});

/**
 * Update the current user's preferred language
 */
export const patchMyPreferredLanguage = <ThrowOnError extends boolean = false>(options: Options<PatchMyPreferredLanguageData, ThrowOnError>): RequestResult<PatchMyPreferredLanguageResponses, PatchMyPreferredLanguageErrors, ThrowOnError> => (options.client ?? client).patch<PatchMyPreferredLanguageResponses, PatchMyPreferredLanguageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/me/preferred-language/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Profile
 */
export const getMyProfile = <ThrowOnError extends boolean = false>(options?: Options<GetMyProfileData, ThrowOnError>): RequestResult<GetMyProfileResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMyProfileResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/me/profile/',
    ...options
});

/**
 * Patch Profile
 */
export const updateMyProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateMyProfileData, ThrowOnError>): RequestResult<UpdateMyProfileResponses, UpdateMyProfileErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMyProfileResponses, UpdateMyProfileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/me/profile/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update most recently used organization
 *
 * Updates the most recently used organization for the current user.
 *
 * - Validates that the user is a member of the specified organization.
 * - Updates the user's most_recently_used_organization_id field.
 *
 * **Permissions:**
 * - Requires a valid Firebase authentication token.
 * - The user must be a member of the organization.
 */
export const updateRecentOrganization = <ThrowOnError extends boolean = false>(options: Options<UpdateRecentOrganizationData, ThrowOnError>): RequestResult<UpdateRecentOrganizationResponses, UpdateRecentOrganizationErrors, ThrowOnError> => (options.client ?? client).patch<UpdateRecentOrganizationResponses, UpdateRecentOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/me/recent-organization/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get one effective runtime setting for the current user
 */
export const getMyRuntimeSetting = <ThrowOnError extends boolean = false>(options: Options<GetMyRuntimeSettingData, ThrowOnError>): RequestResult<GetMyRuntimeSettingResponses, GetMyRuntimeSettingErrors, ThrowOnError> => (options.client ?? client).get<GetMyRuntimeSettingResponses, GetMyRuntimeSettingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/me/runtime-setting/',
    ...options
});

/**
 * Search across all organizations and projects for the user
 *
 * Searches across all organizations and projects that the user is a member of.
 * The search is performed on the name and description of both entities.
 * Results are ranked by relevance.
 *
 * **Permissions:**
 * - Requires a valid Firebase authentication token.
 */
export const globalSearch = <ThrowOnError extends boolean = false>(options: Options<GlobalSearchData, ThrowOnError>): RequestResult<GlobalSearchResponses, GlobalSearchErrors, ThrowOnError> => (options.client ?? client).get<GlobalSearchResponses, GlobalSearchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/user/me/search/',
    ...options
});

/**
 * Get brand information by domain
 *
 * Fetch brand information including logo and icon URLs from Brandfetch.
 *
 * **Parameters:**
 * - **domain**: Company domain (e.g., saab.com, seb.se)
 *
 * **Returns:**
 * - Brand name, domain, and URLs for logo and icon images
 */
export const getBrandInfo = <ThrowOnError extends boolean = false>(options: Options<GetBrandInfoData, ThrowOnError>): RequestResult<GetBrandInfoResponses, GetBrandInfoErrors, ThrowOnError> => (options.client ?? client).post<GetBrandInfoResponses, GetBrandInfoErrors, ThrowOnError>({
    url: '/utilities/brand-info/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
